import { CR_SUBMISSION } from '../constants';
import { getRatingHintByInput } from './get-rating-hint-by-input';

type RatingMouseEnterHandlerParams = {
    hoveredInput: HTMLInputElement;
    rootElement: Pick<HTMLElement, 'querySelector'>;
};
export const RatingMouseEnterHandler = ({ hoveredInput, rootElement }: RatingMouseEnterHandlerParams) => {
    const ratingHint = getRatingHintByInput({ input: hoveredInput });
    const hintSpan = rootElement.querySelector<HTMLSpanElement>(CR_SUBMISSION.STAR_RATING.HINT_SELECTOR);
    return () => {
        if (hintSpan === null) return;
        hintSpan.innerText = ratingHint;
    };
};
